import { createAsyncThunk } from "@reduxjs/toolkit";
import toastHelper from "../../Util/toastHelper";
import API from "../../API/API";
import axios from "axios";

export const getAllGroups = createAsyncThunk(
  "groups/getAllGroups",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axios({
        url: API.admin.getAllGroups.url,
        method: API.admin.getAllBuildings.method,
      });

      return data?.groups;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const getGroupById = createAsyncThunk(
  "groups/getGroupById",
  async (params: { groupId: string }, { rejectWithValue }) => {
    try {
      const { data } = await axios({
        url: API.admin.getGroupById.url + params.groupId,
        method: API.admin.getGroupById.method,
      });

      return data?.group;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const createGroup = createAsyncThunk(
  "groups/createGroup",
  async (
    params: {
      groupName: string;
      terms: string;
      successHandler: () => void;
    },
    { rejectWithValue },
  ) => {
    try {
      const { data } = await axios({
        url: API.admin.createGroup.url,
        method: API.admin.createGroup.method,
        data: params,
      });
      params.successHandler();
      return data?.group;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const updateGroup = createAsyncThunk(
  "groups/updateGroup",
  async (
    params: {
      id: number;
      groupName: string;
      terms: string;
      successHandler: () => void;
    },
    { rejectWithValue },
  ) => {
    try {
      const { data } = await axios({
        url: API.admin.updateGroup.url,
        method: API.admin.updateGroup.method,
        data: params,
      });
      params.successHandler();
      return data;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const getAllAmenityTypes = createAsyncThunk(
  "groups/getAllAmenityTypes",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axios({
        url: API.admin.getAllAmenityTypes.url,
        method: API.admin.getAllAmenityTypes.method,
      });

      return data;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const getAllAmenitiesRateTypes = createAsyncThunk(
  "groups/getAllAmenitiesRateTypes",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axios({
        url: API.admin.getAllAmenitiesRateTypes.url,
        method: API.admin.getAllAmenitiesRateTypes.method,
      });

      return data;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const getAmenitiesByGroupId = createAsyncThunk(
  "groups/getAmenitiesByGroupId",
  async (params: { groupId: string }, { rejectWithValue }) => {
    try {
      const { data } = await axios({
        url: API.admin.getAmenitiesByGroupId.url + params.groupId,
        method: API.admin.getAmenitiesByGroupId.method,
      });
      return data;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const addAmenityByGroupId = createAsyncThunk(
  "groups/addAmenityByGroupId",
  async (
    params: {
      groupId: string;
      name: string;
      amenityTypeId: string;
      rates: string;
      rateTypeId: string;
      rule: string;
      lockId: string;
      image: string;
      isActive: boolean;
      requiresBooking: boolean;
      terms: string;
      doorName: string;
      doorId?: string;
      panelId?: string;
      nonRefundPercent: string;
      isGuest: boolean;
      successHandler: () => void;
    },
    { rejectWithValue },
  ) => {
    try {
      const { data } = await axios({
        url: API.admin.addAmenityByGroupId.url,
        method: API.admin.addAmenityByGroupId.method,
        data: params,
      });

      toastHelper.success("Amenity added successfully");

      params.successHandler();
      return data;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const updateAmenityByGroupId = createAsyncThunk(
  "groups/updateAmenityByGroupId",
  async (
    params: {
      amenityId: string;
      groupId: string;
      name: string;
      amenityTypeId: string;
      rates: string;
      rateTypeId: string;
      rule: string;
      lockId: string;
      image: string;
      isActive: boolean;
      requiresBooking: boolean;
      terms: string;
      doorName: string;
      doorId: string;
      panelId: string;
      nonRefundPercent: string;
      isGuest: boolean;
      successHandler: () => void;
    },
    { rejectWithValue },
  ) => {
    try {
      const { data } = await axios({
        url: API.admin.updateAmenityByGroupId.url,
        method: API.admin.updateAmenityByGroupId.method,
        data: params,
      });

      toastHelper.success("Amenity updated successfully");

      params.successHandler();
      return data;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const getPackagesByGroupId = createAsyncThunk(
  "groups/getPackagesByGroupId",
  async (params: { groupId: string }, { rejectWithValue }) => {
    try {
      const { data } = await axios({
        url: API.admin.getPackagesByGroupId.url + params.groupId,
        method: API.admin.getPackagesByGroupId.method,
      });
      return data;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const addPackageByGroupId = createAsyncThunk(
  "groups/addPackageByGroupId",
  async (
    params: {
      packageName: string;
      packageDescription: string;
      groupId: number;
      status: boolean;
      amenityIds: number[];
      price: number;
      isFreeMonth: boolean;
      isFamily: boolean;
      isMember: boolean;
      isNonMember: boolean;
      noOfMember: number;
      discountRate: number;
      successHandler: () => void;
    },
    { rejectWithValue },
  ) => {
    try {
      const { data } = await axios({
        url: API.admin.addPackageByGroupId.url,
        method: API.admin.addPackageByGroupId.method,
        data: params,
      });

      params.successHandler();
      return data;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const updatePackageById = createAsyncThunk(
  "groups/updatePackageById",
  async (
    params: {
      packageId: number;
      packageName: string;
      packageDescription: string;
      groupId: number;
      status: boolean;
      amenityIds: number[];
      price: number;
      isFreeMonth: boolean;
      discountRate: number;
      isFamily: boolean;
      isMember: boolean;
      isNonMember: boolean;
      noOfMember: number;
      successHandler: () => void;
    },
    { rejectWithValue, dispatch },
  ) => {
    try {
      const { data } = await axios({
        url: API.admin.updatePackageById.url,
        method: API.admin.updatePackageById.method,
        data: params,
      });

      params.successHandler();

      return data;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const deletePackageById = createAsyncThunk(
  "groups/deletePackageById",
  async (
    params: {
      id: number;
      successHandler: () => void;
    },
    { rejectWithValue },
  ) => {
    try {
      const { data } = await axios({
        url: API.admin.deletePackageById.url + params.id,
        method: API.admin.deletePackageById.method,
      });
      toastHelper.success(data?.message);
      params.successHandler();
      return data;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const deleteAmenityByGroupId = createAsyncThunk(
  "groups/deleteAmenityByGroupId",
  async (
    params: {
      id: number;
      groupId: string;
      successHandler: () => void;
    },
    { rejectWithValue, dispatch },
  ) => {
    try {
      const { data } = await axios({
        url: API.admin.deleteAmenityByGroupId.url + params.id,
        method: API.admin.deleteAmenityByGroupId.method,
      });
      params.successHandler();
      dispatch(
        getAmenitiesByGroupId({
          groupId: params.groupId,
        }),
      );
      toastHelper.success(data?.message);
      return data;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const clearGetAmenitiesByGroupId = createAsyncThunk(
  "groups/clearGetAmenitiesByGroupId",
  async (_, { rejectWithValue }) => {
    return null;
  },
);

export const clearGetPackagesByGroupId = createAsyncThunk(
  "groups/clearGetPackagesByGroupId",
  async (_, { rejectWithValue }) => {
    return null;
  },
);

export const clearGetGroupById = createAsyncThunk(
  "groups/clearGetGroupById",
  async (_, { rejectWithValue }) => {
    return null;
  },
);

export const clearCreateGroup = createAsyncThunk(
  "groups/clearCreateGroup",
  async (_, { rejectWithValue }) => {
    return null;
  },
);
